export const fireAndForgetExecuter = (fn: () => void): void => {
  void Promise.resolve().then(fn);
};
